/**
 * /approve-device?token=... -- magic-link landing page.
 * Calls POST /api/devices/approve-token and shows the outcome.
 */

import { html, type TemplateResult } from "lit-html";

import { api, ApiError } from "../api.js";
import { rerender } from "../main.js";

const s = {
  ran: false,
  busy: false,
  approved: false,
  device_id: "",
  err: "",
};

async function run(): Promise<void> {
  if (s.ran) return;
  s.ran = true;
  s.busy = true;
  rerender();
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token") ?? "";
  if (!token) {
    s.err = "missing_token";
    s.busy = false;
    rerender();
    return;
  }
  try {
    const res = await api.deviceApproveByToken(token);
    s.approved = res.approved;
    s.device_id = res.device_id;
  } catch (err) {
    s.err = err instanceof ApiError ? `${err.code}: ${err.message}` : (err as Error).message;
  } finally {
    s.busy = false;
    rerender();
  }
}

export function renderApproveDevice(): TemplateResult {
  void run();
  const errMsg = s.err === "missing_token"
    ? html`<span data-lang="en">Missing token in URL</span><span data-lang="jp">URL にトークンがありません</span>`
    : s.err
      ? html`${s.err}`
      : html`<span data-lang="en">Approval failed</span><span data-lang="jp">承認に失敗しました</span>`;
  return html`
    <div class="login-shell">
      <div class="login-card">
        <h1>
          <span data-lang="en">Device approval</span><span data-lang="jp">デバイス承認</span>
        </h1>
        ${s.busy
          ? html`<p>
              <span data-lang="en">Verifying token…</span><span data-lang="jp">トークンを検証中…</span>
            </p>`
          : s.approved
            ? html`
                <p style="color: var(--status-ok); font-weight: 600;">
                  <span data-lang="en">Device approved.</span><span data-lang="jp">デバイスを承認しました。</span>
                </p>
                <p style="color: var(--text-2); font-size: 13px;">
                  <span data-lang="en">Device ID:</span><span data-lang="jp">デバイス ID:</span> <code>${s.device_id}</code>
                </p>
                <p style="color: var(--text-2); font-size: 13px;">
                  <span data-lang="en">The user can now sign in from this device.</span><span data-lang="jp">該当ユーザーはこのデバイスからサインインできるようになりました。</span>
                </p>
              `
            : html`<p style="color: var(--status-error);">${errMsg}</p>`}
        <button class="primary" style="width: 100%; margin-top: 16px;"
          @click=${() => { window.location.href = "/"; }}>
          <span data-lang="en">Back to vault</span><span data-lang="jp">Vault に戻る</span>
        </button>
      </div>
    </div>
  `;
}
